import messages from './messages';

const Schema = ({ intl }) => {
  const schema = {
    title: intl.formatMessage(messages.clippedImage),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['preview_image'],
      },
    ],

    properties: {
      preview_image: {
        title: intl.formatMessage(messages.previewImage),
        widget: 'object_browser',
        mode: 'image',
        allowExternals: true,
        selectedItemAttrs: ['image_field', 'image_scales'],
      },
    },
    required: ['preview_image'],
  };
  return schema;
};

export default Schema;
